import { Component } from '@angular/core';
import { ConfigService } from './_LOGIC/__config/config.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'VoyJaleas Website';

  constructor(private config: ConfigService){
    this.config.load();
  }
}
